import React, { Component } from 'react';

class TablePadroes extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        var totalEmpreendimentos = 0;
        var ofertaLancada = 0;
        var ofertaFinal = 0;

        return (
            <table className="table table-striped table-condensed table-padroes" style={{border: `3px solid ${this.props.color}`}}>
                <thead>
                    <tr className="text-center" style={{
                        backgroundColor: this.props.color,
                        color: '#ffffff',
                    }} >
                        <td colSpan="8">
                            <span >
                                {this.props.title}
                            </span>
                        </td>
                    </tr>
                    <tr className="text-center" style={{
                        backgroundColor: this.props.color,
                        color: '#ffffff',
                    }}>

                        <th className="text-center" style={{ color: '#ffffff', padding: '7px', }}>
                            <span >
                                Padrão
                            {this.props.title === "VERTICAL" && <button className="btn btn-sm" style={{backgroundColor: this.props.color,color: '#ffffff'}} onClick={this.props.showModalPadraoInfo}><i className="far fa-question-circle"></i></button>}
                            {this.props.title === "COMERCIAL" && <button className="btn btn-sm" style={{backgroundColor: this.props.color,color: '#ffffff'}} onClick={this.props.showModalPadraoInfoComercial}><i className="far fa-question-circle"></i></button>}
                            {this.props.title === "HORIZONTAL - CONDOMÍNIO DE CASAS/SOBRADOS" && <button className="btn btn-sm" style={{backgroundColor: this.props.color,color: '#ffffff'}} onClick={this.props.showModalPadraoInfoCasas}><i className="far fa-question-circle"></i></button>}
                            </span></th>
                        <th className="text-center" style={{ color: '#ffffff', padding: '7px', }}>
                            <span >
                                Nº Emp
                            </span></th>
                        <th className="text-center" style={{ color: '#ffffff', padding: '7px', }}>
                            <span >
                                (%)
                            </span></th>
                        <th className="text-center" style={{ color: '#ffffff', padding: '7px', }}>
                            <span >
                                Oferta Lançada
                            </span>
                        </th>
                        <th className="text-center" style={{ color: '#ffffff', padding: '7px', }}>
                            <span >
                                (%)
                            </span>
                        </th>
                        <th className="text-center" style={{ color: '#ffffff' }}>
                            <span >
                                Oferta Final
                            </span>
                        </th>
                        <th className="text-center" style={{ color: '#ffffff' }}>
                            <span >
                                (%)
                            </span>
                        </th>
                        <th className="text-center" style={{ color: '#ffffff' }}>
                            <span >
                                Dispo. s/O.I
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.padroes.map((padrao, index) => {

                        totalEmpreendimentos += parseInt(padrao.count);
                        ofertaLancada += parseInt(padrao.oferta_inicial);
                        ofertaFinal += parseInt( padrao.oferta_final );

                        return (
                            <tr className="text-center" key={index * 100 + padrao}>
                                <td className="text-center">{padrao.padrao}</td>
                                <td className="text-center">{ padrao.count }</td>
                                <td className="text-center">{Number(padrao.porcentagem_empreendimentos).toFixed(1).toLocaleString().replace('.',',')}</td>
                                <td className="text-center">{Number( padrao.oferta_inicial).toLocaleString()}</td>
                                <td className="text-center">{Number( padrao.oferta_inicial_porcentagem).toFixed(1).toLocaleString().replace('.',',')}</td>
                                <td className="text-center">{Number( padrao.oferta_final).toLocaleString()}</td>
                                <td className="text-center">{Number( padrao.oferta_final_porcentagem).toFixed(1).toLocaleString().replace('.',',')}</td>
                                <td className="text-center">{Number( padrao.oferta_final_porcentagem_sob_oferta_inicial).toFixed(1).toLocaleString().replace('.',',')}</td>
                            </tr>
                        )
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <td className="text-center">Total</td>
                        <td className="text-center">{totalEmpreendimentos.toLocaleString('pt-BR')}</td>
                        <td className="text-center">100%</td>
                        <td className="text-center">{ofertaLancada.toLocaleString('pt-BR')}</td>
                        <td className="text-center">100%</td>
                        <td className="text-center">{ofertaFinal.toLocaleString('pt-BR')}</td>
                        <td className="text-center">100%</td>
                        <td className="text-center">{Number((ofertaFinal / ofertaLancada) * 100).toFixed(1).toLocaleString('pt-BR').replace('.', ',')}</td>
                    </tr>
                </tfoot>
            </table>

        );
    }
}

export default TablePadroes;
